module.exports = __webpack_public_path__ + "static/media/right-caret-clinician-nav.22e99b2a.svg";